export default {
  //获取验证码图片
  getCaptcha: {
    method: 'get',
    url: 'captcha'
  },
  //获取短信验证码
  sendSms: {
    method: 'post',
    url: 'send/sms'
  },
  //获取邮箱验证码
  sendEmail: {
    method: 'post',
    url: 'send/email'
  },
  login: {
    method: 'post',
    url: 'login'
  },
  logout: {
    method: 'post',
    url: 'logout'
  },
  //检查授权状态
  checkLicenseVerify: {
    method: 'get',
    url: 'license/verify'
  },
  activeLicense: {
    method: 'post',
    url: 'license/active'
  }
}
